import React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { TableColumnDef } from "../../components/DataTable";
import type { ContentLanguage } from "../../hooks/useContentLanguage";

const FilePreview = ({ url }: { url?: string }) => {
  if (!url) return <>-</>;
  if (url.slice(-4) === ".pdf") {
    return (
      <a href={url} target="_blank" rel="noreferrer">
        .PDF
      </a>
    );
  }
  return <img style={{ maxWidth: 50 }} alt="img" src={url} />;
};

type ColumnActions = {
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  lang: ContentLanguage;
};

export const buildDocumentColumns = ({
  canEdit,
  canDelete,
  onEdit,
  onDelete,
  lang,
}: ColumnActions): TableColumnDef[] => [
  {
    header: "Titel",
    render: (row: any) => (lang === "de" ? row?.documentName_ger : row?.documentName) || "-",
    getValue: (row: any) => lang === "de" ? row?.documentName_ger : row?.documentName,
  },
  {
    header: "Datei",
    render: (row: any) => <FilePreview url={lang === "de" ? row?.document_ger?.[0] : row?.document?.[0]} />,
  },
  {
    header: "Datum",
    render: (row: any) => moment(row?.createdAt).format("DD.MM.YYYY"),
    getValue: (row: any) => row?.createdAt,
  },
  {
    header: "Einstellungen",
    render: (row: any) => (
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {canEdit && (
          <Tooltip title="Dokument bearbeiten" arrow>
            <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
              <CreateIcon />
            </IconButton>
          </Tooltip>
        )}
        {canDelete && (
          <Tooltip title="Dokument l&ouml;schen" arrow>
            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    ),
  },
];
